import {importLibrary, setOptions} from '@googlemaps/js-api-loader';

let googleMapsPromise = null;
let googleMapsOptionsSet = false;

const setGoogleMapsOptions = function () {
  if (googleMapsOptionsSet) {
    return;
  }
  setOptions({key: process.env.VUE_APP_GOOGLE_API_KEY, v: 'weekly'});
  googleMapsOptionsSet = true;
};

const normalizeGoogleMaps = function ({mapsLibrary, geometryLibrary, placesLibrary, markerLibrary, geocodingLibrary}) {
  const google = window.google || {};
  const maps = google.maps || {};
  Object.assign(maps, mapsLibrary, geocodingLibrary);
  maps.geometry = maps.geometry || geometryLibrary;
  maps.places = maps.places || placesLibrary;
  maps.marker = maps.marker || markerLibrary;
  google.maps = maps;
  window.google = google;
  return google;
};

export const loadGoogleMaps = function () {
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google);
  }
  if (googleMapsPromise) {
    return googleMapsPromise;
  }
  googleMapsPromise = new Promise((resolve, reject) => {
    setGoogleMapsOptions();
    Promise.all([
      importLibrary('maps'),
      importLibrary('geometry'),
      importLibrary('places'),
      importLibrary('marker'),
      importLibrary('geocoding'),
    ])
      .then(([mapsLibrary, geometryLibrary, placesLibrary, markerLibrary, geocodingLibrary]) => {
        const google = normalizeGoogleMaps({
          mapsLibrary,
          geometryLibrary,
          placesLibrary,
          markerLibrary,
          geocodingLibrary,
        });
        if (!google.maps.Map || !google.maps.Geocoder || !google.maps.marker?.AdvancedMarkerElement) {
          const error = new Error('Google Maps loaded without required APIs');
          googleMapsPromise = null;
          reject(error);
          return;
        }
        resolve(google);
      })
      .catch(error => {
        googleMapsPromise = null;
        reject(error);
      });
  });
  return googleMapsPromise;
};

export const initStripeScript = function () {
  if (window.Stripe) {
    return Promise.resolve(window.Stripe);
  }

  return initScript('https://js.stripe.com/v3/').then(() => {
    if (window.Stripe) {
      return window.Stripe;
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (window.Stripe) {
          resolve(window.Stripe);
          return;
        }
        reject(new Error('Stripe did not initialize after loading the Stripe script'));
      }, 50);
    });
  });
};

export const initHubspot = function () {
  return initScript('//js.hs-scripts.com/20577381.js');
};

export const initHotjar = function () {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = {hjid: process.env.VUE_APP_HOTJAR_ID, hjsv: 6};
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};

export const initGoogleAnalytics4 = function (id) {
  initScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id);
};

export const initScript = function (src) {
  /* Inits the script, makes sure script is not inited twice. Returns Promise, will be resolved once script is loaded */
  return new Promise(function (resolve, reject) {
    let script = document.querySelector('script[src="' + src + '"]');
    if (script && script.hasAttribute('data-loaded')) {
      return resolve(script);
    }
    let shouldAppend = false;
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('src', src);
      script.async = true;
      shouldAppend = true;
    }
    script.addEventListener('error', reject);
    script.addEventListener('abort', reject);
    script.addEventListener('load', () => {
      script.setAttribute('data-loaded', 'true');
      resolve(script);
    });
    if (shouldAppend) {
      document.head.appendChild(script);
    }
  });
};

export const initStylesheet = function (href, id) {
  if (!document.getElementById(id)) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    link.media = 'all';
    head.appendChild(link);
  }
};
